import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { PermissionDto, ResponseDto, UserDto, UserPermissionPayloadDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpUserService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/user');
	}

	saveUser(input: UserDto): Observable<ResponseDto> {
		return super.post(`/save`, input);
	}
	checkUsername(input: UserDto): Observable<ResponseDto> {
		return super.post(`/check-username`, input);
	}
	//Used by an admin to reset another users password
	resetPassword(input: UserDto): Observable<ResponseDto> {
		return super.post(`/reset-password`, input);
	}
	//Used by the user logged in, who needs to change password due to status = New, or if they wish to just change it.
	changePassword(input: UserDto): Observable<ResponseDto> {
		return super.post(`/change-password`, input);
	}
	getAllUsers(input: UserDto): Observable<UserDto[]> {
		return super.post(`/get-all`, input);
	}
	getAllUsersMinified(input: UserDto): Observable<UserDto[]> {
		return super.post(`/get-all-minified`, input);
	}
	getUserById(input: number): Observable<UserDto> {
		return super.get(`/${input}/get-by-id`);
	}
	getAllPermissions(): Observable<PermissionDto[]> {
		return super.get(`/get-all-permissions`);
	}
	getUserPermissions(userId: number): Observable<PermissionDto[]> {
		return super.get(`/${userId}/get-user-permissions`);
	}
	updateUserPermissions(userId: number, permissionIds: number[]): Observable<ResponseDto> {
		var payload: UserPermissionPayloadDto = {
			userId: userId,
			permissionIds: permissionIds
		}
		return super.post(`/update-user-permissions`, payload);
	}
	userAction(input: UserDto, type: 'enable' | 'disable' | 'unblock'): Observable<ResponseDto> {
		switch (type) {
			case 'enable':
				return super.post(`/enable`, input);
			case 'disable':
				return super.post(`/disable`, input);
			case 'unblock':
				return super.post(`/unblock`, input);
			default:
				return of({success: false, error: 'Invalid action'});
		}
		
	}

}
